import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSupportOnly } from "@/hooks/useSupportOnly";

/**
 * Layout gate for support-only tenants (e.g. "heybay").
 *
 * When the tenant is support-only, the dashboard is locked to the Help Center.
 * Any route outside the allowlist is redirected to /support — so hiding the nav
 * items is backed by real enforcement (a curious user can't reach /orders by
 * typing the URL). Renders <Outlet/> unchanged for every normal tenant.
 *
 * Allowlist:
 *  - /support (+ compose/detail sub-routes) — the whole point
 *  - /settings — the rail avatar links here; it's the only surface with account
 *    management + logout, so support-only users must still reach it.
 */
const ALLOWED_PREFIXES = ["/support", "/settings"];

export function SupportOnlyGate() {
  const supportOnly = useSupportOnly();
  const { pathname } = useLocation();

  if (supportOnly) {
    const allowed = ALLOWED_PREFIXES.some(
      (p) => pathname === p || pathname.startsWith(p + "/")
    );
    if (!allowed) {
      return <Navigate to="/support" replace />;
    }
  }

  return <Outlet />;
}
